import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';
import { CompanyService } from 'src/app/core/services/company.service';
import { DocumentService } from 'src/app/core/services/document.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AngularModalService } from 'src/app/core/services/modal.service';
import { DocumentActionService } from 'src/app/core/services/document-action-service';
import { SharedService } from 'src/app/core/services/shared.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { MESSAGECONSTANTS } from 'src/app/core/utils/constants';
import { Folder } from 'src/app/core/models/Folder';
import { Document } from 'src/app/core/models/Document';
import {
  CandidateProfileActionsModalComponent
} from 'src/app/pages/mission-control-page/candidateprofile-page/candidate-profile-actions-modal/candidate-profile-actions-modal.component';

@Component({
  selector: 'app-candidate-documents',
  templateUrl: './candidate-documents.component.html',
  styleUrls: ['./candidate-documents.component.css']
})
export class CandidateDocumentsComponent implements OnInit {
  @Input() candidateId: string;
  @Input() candidateType: any;
  @Input() candidateDetails: any;
  @Input() sourceScreen: string;
  @Input() formalizeActivityPayload: any;
  @Output() saveCallback = new EventEmitter<any>();
  @Output() cancelCallback = new EventEmitter<any>();

  MESSAGECONSTANTS: any = MESSAGECONSTANTS;

  userId: any;
  companyId: any;
  isCorporate: boolean;
  loadingFolders = true;
  skeletonPlaceholderFolders = [
    'width-50', 'width-75', 'width-25', 'width-50', 'width-75',
    'width-50', 'width-25', 'width-75', 'width-50', 'width-25'
  ];
  isSharedDocumentActionAvailable = true;
  folders: any[] = [];
  allFoldersList: any[] = [];
  candidateJobMatchFolders: any[] = [];
  allAvailableDocuments: any[] = [];
  companiesToShareCandidateDocuments: any[] = [];
  selectedFolder: any;

  constructor(
    private authService: AuthService,
    private companyService: CompanyService,
    private documentService: DocumentService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private modalService: AngularModalService,
    private documentActionService: DocumentActionService,
    private bsModalService: BsModalService,
    private sharedService: SharedService
  ) { }

  ngOnInit() {
    this.userId = this.authService.userDetails.id;
    this.companyId = this.authService.userDetails.company.companyId;
    this.isCorporate = this.companyService.isCorporateCompany();
    this.loadingFolders = true;
    this.isSharedDocumentActionAvailable = true;
    this.folders = [];
    this.allFoldersList = [];
    this.candidateJobMatchFolders = [];
    this.allAvailableDocuments = [];
    this.companiesToShareCandidateDocuments = [];
    this.getAllCandidateFolders(() => {
      if (this.folders.length > 0) {
        if (this.candidateDetails && this.candidateDetails.folderId && this.candidateDetails.isNotification) {
          this.onFolderSelect(this._getFolderById(this.candidateDetails.folderId));
        } else {
          this.onFolderSelect(this.folders[0]);
        }
      }
    });
  }

  private _setCandidateJobMatchFolders(jobMatches: any) {
    this.candidateJobMatchFolders = [];
    this.candidateJobMatchFolders = this.documentActionService.setCandidateJobMatchFolders(jobMatches, this.companyId, this.candidateId);
  }

  private _setAllAvailableDocumentsInfolders() {
    let allDocuments: any[] = [];
    let parentDocuments: any[] = [];
    let childDocuments: any[] = [];
    this.folders.forEach(folder => {
      parentDocuments = [...folder.documents];
      childDocuments = [];
      folder.folders.forEach((subFolder: any) => {
        childDocuments = [...childDocuments, ...subFolder.documents];
      });
      allDocuments = [...allDocuments, ...parentDocuments, ...childDocuments];
    });

    this.candidateJobMatchFolders.map(jobMatchFolder => {
      if (jobMatchFolder.documents.length > 0) {
        allDocuments.push(...jobMatchFolder.documents);
      }
    });

    this.allAvailableDocuments = allDocuments;
  }

  getAllCandidateFolders(successCallback: () => void) {
    this.loadingFolders = true;
    this.documentService.getAllCandidateFolders(this.candidateId, this.companyId, this.candidateType, (data: any) => {
      this._setFolders(data.candidateDocuments);
      this._setDocumentSharedOption(data);
      this._setCandidateJobMatchFolders(data.jobMatchesDocuments);
      this._setAllAvailableDocumentsInfolders();
      this.folders = this.documentActionService.setSharedFolderWithDocuments(this.folders, this.candidateId, this.companyId);
      this.companiesToShareCandidateDocuments = this.setCompaniesToSharedCandidateDocuments(data);
      this.loadingFolders = false;
      if (successCallback) {
        successCallback();
      }
    }, (error: any) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  private _setFolders(folders: any[]) {
    this.folders = [];
    folders.forEach(folder => {
      this.allFoldersList.push(folder);
      folder.folders.forEach((subFolder: any) => {
        subFolder.parentFolderId = folder.id;
        subFolder.parentFolderName = folder.name;
        this.allFoldersList.push(subFolder);
      });
    });
    this.folders = folders;

    this.documentActionService._setDocumentIcons(this.folders);
  }

  onFolderSelect(selectedFolder: any) {
    this.selectedFolder = selectedFolder;
    if (selectedFolder && selectedFolder.isJobMatchFolders) {
      this.candidateJobMatchFolders.map(jobMatchFolder => {
        jobMatchFolder.active = jobMatchFolder.id === selectedFolder.id;
      });
    } else {
      if (this.folders.length > 0) {
        this.folders.forEach(folder => {
          folder.active = folder.id === (selectedFolder && selectedFolder.id);
          folder.folders.forEach((sub: any) => {
            sub.active = sub.id === (selectedFolder && selectedFolder.id);
          });
        });
      }
    }
  }

  addDocumentFolder(parentFolder?: any) {
    const actionType = 'addEditDocumentFolder';
    const actionLabel = 'Add Document Folder';
    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
    setTimeout(() => {
      const candidateProfileActionsModal = this.bsModalService.show(CandidateProfileActionsModalComponent, {
        initialState: {
          actionType,
          actionLabel,
          parentFolderName: parentFolder ? parentFolder.name : null,
          folder: new Folder('', '', parentFolder ? parentFolder.id : null, this.companyId, this.candidateId),
          folders: this.folders
        },
        class: 'custom-candidate-profile-modal custom-modal-65'
      });

      candidateProfileActionsModal.content.onClose.subscribe((callbackObject: any) => {
        if (!callbackObject) {
          return;
        }
        this.getAllCandidateFolders(() => {
          if (callbackObject && callbackObject.entity && callbackObject.entity.id) {
            this.onFolderSelect(this._getFolderById(callbackObject.entity.id));
          } else if (this.selectedFolder && this.selectedFolder.id && !this.selectedFolder.isJobMatchFolders) {
            this.onFolderSelect(this._getFolderById(this.selectedFolder.id));
          } else {
            this.onFolderSelect(this.folders[0]);
          }
        });
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      });
    }, 300);
  }

  private _getFolderById(folderId: any) {
    const parentFolder = this.folders.find(folder => folder.id === folderId);
    if (parentFolder) {
      return parentFolder;
    }
    for (const folder of this.folders) {
      const subFolder = folder.folders.find((sub: any) => sub.id === folderId);
      if (subFolder !== undefined) {
        return subFolder;
      }
    }
  }

  editDocumentFolder(folder: any) {
    const actionType = 'addEditDocumentFolder';
    const actionLabel = 'Edit Document Folder';
    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
    setTimeout(() => {
      const candidateProfileActionsModal = this.bsModalService.show(CandidateProfileActionsModalComponent, {
        initialState: {
          actionType,
          actionLabel,
          folder: _.cloneDeep(folder),
          folders: this.folders
        },
        class: 'custom-candidate-profile-modal custom-modal-65'
      });

      candidateProfileActionsModal.content.onClose.subscribe((callbackObject: any) => {
        if (!callbackObject) {
          return;
        }
        this.getAllCandidateFolders(() => {
          this.onFolderSelect(this._getFolderById(folder.id));
        });
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      });
    }, 300);
  }

  moveDocumentFolder(folder: any) {
    const spreadFolders: any[] = [];
    this.folders.forEach(parentFolder => {
      if (this._notCurrentAndParentFolder(parentFolder, folder)) {
        spreadFolders.push(parentFolder);
      }
      folder.folders.forEach((subFolder: any) => {
        if (this._notCurrentAndParentFolder(subFolder, folder)) {
          spreadFolders.push(subFolder);
        }
      });
    });

    if (folder.parentFolderId) {
      spreadFolders.push({ name: 'Root', id: 'root' });
    }

    if (spreadFolders.length === 0) {
      this.alertsAndNotificationsService.showAlert('No folders found', 'No folders available.', 'warning');
    } else {
      const actionType = 'moveDocumentFolder';
      const actionLabel = 'Move Folder';
      this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      setTimeout(() => {
        const candidateProfileActionsModal = this.bsModalService.show(CandidateProfileActionsModalComponent, {
          initialState: {
            actionType,
            actionLabel,
            folder: _.cloneDeep(folder),
            parentFolders: spreadFolders
          },
          class: 'custom-candidate-profile-modal custom-modal-65'
        });

        candidateProfileActionsModal.content.onClose.subscribe((callbackObject: any) => {
          if (!callbackObject) {
            return;
          }
          this.getAllCandidateFolders(() => {
            this.onFolderSelect(this.folders[0]);
          });
          this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        });
      }, 300);
    }
  }

  private _notCurrentAndParentFolder(folder: any, folderToMove: any) {
    return folder.id !== folderToMove.id && folder.id !== folderToMove.parentFolderId &&
      folder.parentFolderId !== folderToMove.id && folder.id !== 'sharedFolder';
  }

  moveDocument(document: any) {
    const spreadFolders: any[] = [];
    this.folders.forEach(parentFolder => {
      if (parentFolder.id !== document.folderId && parentFolder.id !== 'sharedFolder') {
        spreadFolders.push(parentFolder);
      }
      parentFolder.folders.forEach((subFolder: any) => {
        if (subFolder.id !== document.folderId) {
          spreadFolders.push(subFolder);
        }
      });
    });

    if (spreadFolders.length === 0) {
      this.alertsAndNotificationsService.showAlert('No folders found', 'No folders available.', 'warning');
    } else {
      const sharedTo = document && document.sharedTo ? document.sharedTo.map((sharedDoc: any) => sharedDoc.id) : [];
      const actionType = 'moveDocument';
      const actionLabel = 'Move Document';
      this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      setTimeout(() => {
        const candidateProfileActionsModal = this.bsModalService.show(CandidateProfileActionsModalComponent, {
          initialState: {
            actionType,
            actionLabel,
            document: new Document(document.id, document.fileName, '', this.candidateId, this.companyId,
              document.note, document.folderId, sharedTo, document.shared, ''),
            parentFolders: spreadFolders,
            candidateType: this.candidateType,
            allFoldersList: this.allFoldersList,
            candidateDetails: this.candidateDetails
          },
          class: 'custom-candidate-profile-modal custom-modal-65'
        });

        candidateProfileActionsModal.content.onClose.subscribe((callbackObject: any) => {
          if (callbackObject && callbackObject.entity && callbackObject.entity.id) {
            this.getAllCandidateFolders(() => {
              this.onFolderSelect(this._getFolderById(this.selectedFolder.id));
            });
          }
          this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        });
      }, 300);
    }
  }

  deleteDocument(document: any) {
    this.documentActionService.setParentAndChildFolderName(this.allFoldersList, document);
    const deleteDocumentPayload: any = {};
    deleteDocumentPayload.candidateId = this.candidateId;
    deleteDocumentPayload.companyId = this.companyId;
    deleteDocumentPayload.folderId = document.folderId;
    deleteDocumentPayload.documentId = document.id;
    deleteDocumentPayload.userId = this.userId;
    deleteDocumentPayload.candidateType = this.candidateType;
    deleteDocumentPayload.keepLastVersion = false;
    deleteDocumentPayload.folderName = document.folderName;
    deleteDocumentPayload.parentFolderName = document.parentFolderName;
    deleteDocumentPayload.sharedEntityIds = document && document.sharedTo ?
      document.sharedTo.map((sharedDoc: any) => sharedDoc.id).toString() : '';
    if (this.candidateDetails.jobMatchId) {
      deleteDocumentPayload.jobMatchId = this.candidateDetails.jobMatchId;
    }
    if (document.version === 1) {
      const message = 'Are you sure you want to delete the document?';
      this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      this.alertsAndNotificationsService.showConfirm('Delete Document', message, 'warning', false, () => {
        deleteDocumentPayload.keepLastVersion = false;
        this.documentService.deleteCandidateDocument(deleteDocumentPayload, () => {
          this.getAllCandidateFolders(() => {
            this.onFolderSelect(this._getFolderById(this.selectedFolder.id));
          });
          this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        }, (error: any) => {
          this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
          this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        });
      }, () => {
        // do nothing
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      });
    } else {
      const actionType = 'deleteDocument';
      const actionLabel = 'Delete Document';
      this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      setTimeout(() => {
        const candidateProfileActionsModal = this.bsModalService.show(CandidateProfileActionsModalComponent, {
          initialState: {
            actionType,
            actionLabel,
            document: new Document(document.id, document.fileName, '', this.candidateId, this.companyId,
              document.note, document.folderId, [], document.shared, ''),
            deleteDocumentPayload,
            candidateDetails: this.candidateDetails
          },
          class: 'custom-candidate-profile-modal custom-modal-65'
        });

        candidateProfileActionsModal.content.onClose.subscribe((callbackObject: any) => {
          if (!callbackObject) {
            return;
          }
          this.getAllCandidateFolders(() => {
            if (this.selectedFolder && this.selectedFolder.id) {
              this.onFolderSelect(this._getFolderById(this.selectedFolder.id));
            }
          });
          this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        });
      }, 300);
    }
  }

  deleteDocumentFolder(folder: any) {
    let message = 'Are you sure you want to delete this folder?';
    let preMessage = '';
    const foldersCount = folder.folders.length;
    const documentsCount = folder.documents.length;
    if (foldersCount > 0 && documentsCount > 0) {
      const foldersMessage = foldersCount > 1 ? `There are ${foldersCount} folders` : `There is ${foldersCount} folder`;
      const documentsMessage = documentsCount > 1 ? `${documentsCount} documents` : `${documentsCount} document`;
      message = `${foldersMessage} and ${documentsMessage} in this folder.<br>${message}`;
    } else if (foldersCount > 0) {
      preMessage = foldersCount > 1 ? `There are ${foldersCount} folders in this folder.`
        : `There is ${foldersCount} folder in this folder.`;
      message = `${preMessage}<br>${message}`;
    } else if (documentsCount > 0) {
      preMessage = documentsCount > 1 ? `There are ${documentsCount} documents in this folder.`
        : `There is ${documentsCount} document in this folder.`;
      message = `${preMessage}<br>${message}`;
    }
    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
    this.alertsAndNotificationsService.showConfirm('Delete Folder', message, 'warning', false, () => {
      this.documentService.deleteCandidateDocumentFolder(folder.id, () => {
        this.getAllCandidateFolders(() => {
          this.onFolderSelect(this.folders[0]);
        });
      }, (error: any) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      });
      this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
    }, () => {
      // do nothing
      this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
    });
  }

  onAddDocument(document?: any, action?: string) {
    let actionType = 'uploadCandidateDocument';
    let actionLabel = 'Add Document';
    let showUpload = true;
    if (document) {
      actionLabel = 'Upload New Version';
    }
    if (action && action === 'edit') {
      showUpload = false;
      actionLabel = 'Edit Document';
    } else if (action && action === 'share') {
      showUpload = false;
      actionType = 'shareCandidateDocument';
      actionLabel = 'Share Document';
    }
    let documentToUpdate: any;
    const sharedTo = document && document.sharedTo ? document.sharedTo.map((sharedDoc: any) => sharedDoc.id) : [];
    if (document) {
      documentToUpdate = new Document(document.id, document.fileName, '', this.candidateId, this.companyId,
        document.note, document.folderId, sharedTo, document.shared, '');
    } else {
      documentToUpdate = new Document(null, '', '', this.candidateId, this.companyId, '', this.selectedFolder.id, [], false, '');
    }
    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
    setTimeout(() => {
      const candidateProfileActionsModal = this.bsModalService.show(CandidateProfileActionsModalComponent, {
        initialState: {
          actionType,
          actionLabel,
          document: documentToUpdate,
          showUpload,
          candidateType: this.candidateType,
          candidateDetails: this.candidateDetails,
          allFoldersList: this.allFoldersList,
          isSharedDocumentActionAvailable: this.isSharedDocumentActionAvailable,
          companiesToShareCandidateDocuments: this.companiesToShareCandidateDocuments
        },
        class: 'custom-candidate-profile-modal custom-modal-65'
      });

      candidateProfileActionsModal.content.onClose.subscribe((callbackObject: any) => {
        if (!callbackObject) {
          return;
        }
        this.getAllCandidateFolders(() => {
          this.onFolderSelect(this._getFolderById(this.selectedFolder.id));
        });
        this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      });
    }, 300);
  }

  mailDocument(document: any) {
    const actionType = 'emailDocument';
    const actionLabel = 'Email Document';
    const documentToMail = document.isJobMatchDocument ? document : new Document(document.id, document.fileName, '',
      this.candidateId, this.companyId, document.note, document.folderId, [], document.shared, '');
    this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
    setTimeout(() => {
      this.bsModalService.show(CandidateProfileActionsModalComponent, {
        initialState: {
          actionType,
          actionLabel,
          documents: _.cloneDeep(this.allAvailableDocuments),
          document: _.cloneDeep(documentToMail),
          folders: _.cloneDeep(this.folders),
          candidateJobMatchFolders: _.cloneDeep(this.candidateJobMatchFolders),
          candidateDetails: this.candidateDetails,
          sourceScreen: this.sourceScreen,
          formalizeActivityPayload: this.formalizeActivityPayload
        },
        class: 'custom-candidate-profile-modal custom-modal-xl'
      });
    }, 300);
  }

  private _setDocumentSharedOption(folderData: any) {
    if (this.candidateDetails) {
      if (this.candidateDetails.context === 'candidateJobMatchCard' && !this.candidateDetails.isSharedRequisition) {
        this.isSharedDocumentActionAvailable = false;
      } else if (this.candidateDetails.context === 'candidateCard' && this.isCorporate &&
        this.candidateDetails.candidateType === 'OWN_CANDIDATES') {
        this.isSharedDocumentActionAvailable = false;
      } else if (this.candidateDetails.context === 'candidateCard' && !this.isCorporate) {
        this.isSharedDocumentActionAvailable = folderData.sharedCandidate;
      }
    }
  }

  setCompaniesToSharedCandidateDocuments(data: any) {
    let companies = this.isCorporate ? data.documentToShareVendors : data.documentToShareCorporates;
    if (companies && companies.length > 1 && !this.isCorporate && this.candidateDetails.corporateName) {
      companies = companies.filter((company: any) => this.candidateDetails.corporateName === company.name);
    }
    return companies;
  }

  viewDocumentFIle(file: any) {
    this.sharedService.viewDocumentFile(file, () => { }, () => { });
  }
}
